import styles from "./styles/ChatSuggestions.module.css";
import { useAtomValue, useSetAtom } from "jotai";
import React from "react";
import { allSuggestionsAtom, currentActionAtom } from "./atoms";
import log from "cslog";
import classNames from "classnames";

function ChatSuggestions({
  onReset = () => {},
  onSendMessage = () => {},
  is_bottom = false,
}) {
  const suggestins = useAtomValue(allSuggestionsAtom);
  const performAction = useSetAtom(currentActionAtom);

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.bottom]: is_bottom,
      })}
    >
      {suggestins.map((suggestion, index) => {
        return (
          <div
            key={index}
            onClick={() =>
              performAction({
                ...suggestion.action,
                key: Date.now(),
              })
            }
            className={styles.item}
          >
            {suggestion.name}
          </div>
        );
      })}
    </div>
  );
}

export default ChatSuggestions;
